var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"充值油返利给承运司机比例"}},[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm,"labelWidth":"160px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }